<template>
<div class="clubSignUp">
  <img class="clubSignUp__left" :src="require('@/assets/img/club/signup.png')"/>
  <section class="clubSignUp__right">
    <form class="clubSignUp__form">
      <label class="clubSignUp__textLabel">Имя</label>
      <form-input v-model="clubSignUpStore.firstName" :name-only="true"/>

      <label class="clubSignUp__textLabel">Фамилия</label>
      <form-input v-model="clubSignUpStore.lastName" :name-only="true"/>

      <label class="clubSignUp__textLabel">Почта</label>
      <form-input v-model="clubSignUpStore.email"/>

      <label class="clubSignUp__textLabel">Область, Город </label>
      <form-input v-model="clubSignUpStore.city"/>


      <label class="clubSignUp__textLabel">Номер телефона для связи</label>
      <phone-input v-model="clubSignUpStore.phone" :error="phoneError"/>

      <label class="clubSignUp__textLabel">Навыки и компетенции, которыми обладаете ('рисую', 'python', 'аналитик данных'). </label>
      <form-input
          rows="3"
          height="77px"
          v-model="clubSignUpStore.info"
      />

      <label class="clubSignUp__textLabel--muted ">
        Эта информация поможет подобрать близкий по духу круг для творческих собраний и инициатив
      </label>

      <CheckBox
          v-model="acceptFirst"
          @change="acceptFirstError = ''"
      >
        Я соглашаюсь <ConsentLink slug="consent-club">с уставом и условиями Клуба КиберДеда</ConsentLink>
      </CheckBox>
      <div v-if="acceptFirstError" class="clubSignUp__consentError">{{ acceptFirstError }}</div>
      <CheckBox
          v-model="acceptSecond"
          text=""
          @change="acceptSecondError = ''"
      >
        Я соглашаюсь на <ConsentLink slug="consent-personal">обработку персональных данных</ConsentLink>

      </CheckBox>
      <div v-if="acceptSecondError" class="clubSignUp__consentError">{{ acceptSecondError }}</div>

      <div class="clubSignUp__Buttons">
        <ActionButton
            class="clubSignUp__Buttons-submit"
            icon-type="arrow"
            :disabled="clubSignUpStore.loading"
            @button-click="clubSignUpHandler"
        >
          <template #caption>Подать заявку</template>
        </ActionButton>
        <ActionButton
            class="clubSignUp__Buttons-cancel"
            @button-click="$router.push({name: 'ClubView'})"
        >
          <template #caption>Отмена</template>
        </ActionButton>

      </div>

    </form>
  </section>

</div>
</template>

<script>
import CheckBox from "@/components/ui/CheckBox.vue";
import ActionButton from "@/components/ui/ActionButton.vue";
import FormInput from "@/components/ui/FormInput.vue";
import PhoneInput from "@/components/ui/PhoneInput.vue";
import ConsentLink from "@/components/ui/ConsentLink.vue";
import {useClubSignUpStore} from "@/store/club-signup";
import {computed, onMounted, ref} from "vue";
import {useRouter} from "vue-router";
import {useToast} from "vue-toast-notification";
import {checkPhone} from "@/tools/validation.tools";


export default {
  name: "ClubSignUpView",
  components: {FormInput, PhoneInput, ActionButton, CheckBox, ConsentLink},
  setup() {
    const router = useRouter();
    const toast = useToast();
    const clubSignUpStore = useClubSignUpStore();
    const acceptFirst = ref(false)
    const acceptSecond = ref(false)
    const acceptFirstError = ref('')
    const acceptSecondError = ref('')

    const phoneError = computed(() => checkPhone(clubSignUpStore.phone, true) ? '' : 'Введите полный номер телефона');

    onMounted( () => {
      console.log('ClubSignUpView mounted');
      clubSignUpStore.fillFromUserSettings();
    })

    async function clubSignUpHandler() {
      console.log('clubSignUpHandler invoked');
      acceptFirstError.value = acceptFirst.value ? '' : 'Подтвердите согласие с уставом и условиями клуба';
      acceptSecondError.value = acceptSecond.value ? '' : 'Подтвердите согласие на обработку персональных данных';
      if (acceptFirstError.value || acceptSecondError.value) {
        return;
      }
      const signup = await clubSignUpStore.clubSignUp({
        acceptClubTerms: acceptFirst.value,
        acceptPersonalData: acceptSecond.value,
      })
      if(clubSignUpStore.error) {
        toast.error(clubSignUpStore.error);
        return;
      }
      if (signup?.status === 'approved') {
        await router.push({name: 'ClubSignupStatusView'});
        return;
      }
      await router.push({name: 'ClubSignUpFinishView'})
    }

    return {
      clubSignUpStore, acceptFirst, acceptSecond, acceptFirstError, acceptSecondError, clubSignUpHandler, phoneError
    }
  }
}
</script>


<style scoped lang="scss">
.clubSignUp {
  display: flex;
  align-items: flex-start;
  padding-top: 60px;
  gap: 22px;
  &__left {
    flex: 1 1 300px;
    max-width: 100%;
    height: auto;
    border-radius: 20px;
  }
  &__right {
    flex: 1 1 400px;
    min-width: 0;
    border-radius: 20px;
    background: var(--cd-card-bg);
    padding: 34px;
  }

  &__textLabel {
    padding: 10px 10px;
    display: block;
  }
  &__textLabel--muted {
    display: block;
    color: var(--cd-text-muted);
    margin: 20px 0px;
  }

  &__form {
    text-align: left;
    width: 100%;
    max-width: 663px;
    font-size: 14px;
    font-weight: 400;
    font-family: var(--cd-default-font);
  }
  &__consentError {
    color: var(--cd-danger);
    font-size: 13px;
    margin: -6px 0 8px 28px;
  }

  &__Buttons {
    &-submit,
    &-cancel {
      width: 180px;
    }
  }

  @include respond-to('md') {
    flex-direction: column;
    padding-top: 32px;
    gap: 16px;

    // На мобильных фото скрываем — форма занимает всю ширину
    &__left {
      display: none;
    }
    &__right {
      flex: none;
      width: 100%;
      padding: 24px 20px;
    }
    &__form {
      max-width: none;
    }
    &__Buttons {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin-top: 24px;

      &-submit,
      &-cancel {
        width: 100%;
      }
    }
  }

  @include respond-to('sm') {
    padding-top: 24px;
    gap: 12px;

    &__right {
      padding: 16px 14px;
    }
    &__textLabel {
      padding: 8px 8px;
    }
    &__consentError {
      margin-left: 20px;
      font-size: 12px;
    }
    &__Buttons {
      margin-top: 16px;
      gap: 8px;
    }
  }
}
</style>
